import ModelLeftIndex from '@view/page/selfModelFakeLeft/modelLeftIndex'

const LeftComp = (props) => {      
    return (
        <ModelLeftIndex {...props} />
    )
}

export default LeftComp